import React from 'react';
import { useSelector } from 'react-redux';
import { LOGIN_STEP as LS } from 'state/login/types';
import PropTypes from 'prop-types';
import { useAppTitle } from '@lwtears/lwt-common-frontend/lib/@common';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import Header from './Header';
import common from '../style/common.module.scss';

const t = (key) => translate('common', key);
const tApp = (app, key) => translate(app, key);

const LoginUsers = ({ selectUser, goToStep, users, contentScaling }) => {
  const app = useSelector((state) => state.login.app);

  useAppTitle(`${t('ChooseYourUser')} - ${t('StudentLogin')} - ${tApp(app, 'appTitle')}`);

  const usersList = users.map((user, id) => {
    return (
      <li key={id}>
      <button
       
        className={['login-button', common.listItem, common[`listItem${contentScaling}`]].join(' ')}
        onClick={async () => await selectUser(user.id)}
      >
        <p id={`student-${id + 1}`}>{user.username}</p>
      </button>
      </li>
    );
  });

  return (
    <div className={common.selectPage}>
      <Header message={t('name')} goToStep={goToStep} previousStep={LS.SHOW_CLASSES} />
      <div className={[common.content, common[`content${contentScaling}`]].join(' ')}>
        <h2 className={[common.heading, common[`heading${contentScaling}`]].join(' ')}>
          {t('ChooseYourUser')}
        </h2>
        <ul className={common.list} id="user-list">
          {usersList}
        </ul>
      </div>
    </div>
  );
};

LoginUsers.propTypes = {
  selectUser: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
  users: PropTypes.array.isRequired,
  contentScaling: PropTypes.number
};

export default LoginUsers;
